import {NavbarMode} from '@navbar-unlogged-types';
import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware} from '#imports';
import {useNavbarMode} from '../composables/useNavbarMode';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    if (to.meta.navbar && isValidNavbarMode(to.meta.navbar as string)) {
        const {switchMode} = useNavbarMode();
        switchMode(to.meta.navbar as NavbarMode);
    }

    function isValidNavbarMode(mode: string): mode is NavbarMode {
        return Object.values(NavbarMode).includes(mode as NavbarMode);
    }
});
